export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/opt_pk_thumbnail-9cbfa4debef036a96dd99f54e149c017.jpg";